import colors from '../../configs/colors';
const {grey15, white} = colors;
export const getRowBackgroundColor = (isOddRow: boolean) => {
  return isOddRow ? grey15 : white;
};
